export default __webpack_public_path__ + "static/media/close_popup.a23d79dd.svg";